module.exports = __webpack_public_path__ + "static/media/flag-mn.524bbc43.webp";